import { BlockedEntity, BlockedEntityTab } from '../model/types';
import { ELinksName } from 'services/constants/list-links-sidebar';
import { ETabsUsersDetails } from 'services/constants/lists-table';

export const formatDateTime = (value?: string | null): string => {
  if (!value) return 'Not provided';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const initials = (value: string): string => {
  const result = value
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
  return result || '?';
};

export const getManagementPath = (entity: BlockedEntity): string => {
  if (entity.kind === 'users') {
    return `${ELinksName.USER_DETAILS}/${entity.id}/registered/${String(
      ETabsUsersDetails.USER_DATA,
    )}`;
  }

  if (entity.kind === 'groups') {
    return `${ELinksName.GROUPS_DETAILS}/${entity.id}/groups-data`;
  }

  return `${ELinksName.CHANNEL_DETAIL_USER}/${entity.id}/all-channels`;
};

export const getTabLabel = (tab: BlockedEntityTab): string => {
  if (tab === 'groups') return 'Groups';
  if (tab === 'channels') return 'Channels';
  return 'Users';
};

export const valueFromRecord = (
  source: Record<string, unknown> | null | undefined,
  keys: string[],
): string => {
  for (const key of keys) {
    const value = source?.[key];
    if (value !== undefined && value !== null && value !== '') return String(value);
  }
  return '';
};
